import { render, staticRenderFns } from "./TasksSnackbar.vue?vue&type=template&id=0f9c6df7&"
import script from "./TasksSnackbar.vue?vue&type=script&lang=js&"
export * from "./TasksSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports